import React, { useContext } from "react";

import * as Contexts from "../../../../contexts";
import * as Table from "../../../../components/Table";

import { useHistory } from "react-router-dom";
import { useHttp } from "../../../../hooks";
import { config, Translater } from "../../../../config";
import { ITrackProps } from "./types";
import { getStringFromTranslationsArr } from "../../../../helpers";

const Track: React.FC<ITrackProps> = ({ data, order, reloadHandler }) => {
  const { token } = useContext(Contexts.AuthContext);
  const { access } = useContext(Contexts.UserContext);
  const { language } = useContext(Contexts.LanguageContext);

  const { request } = useHttp();
  const history = useHistory();

  const Events = {
    deleteHandler: () => {
      const answer = window.confirm(Translater.Alert.delete[language.slug]);
      if (answer) Callbacks.Delete();
    },
    editHandler: () => {
      history.push(`/banners/${data._id}`);
    },
  };

  const Callbacks = {
    Delete: async () => {
      try {
        await request(`${config.API}/stocks/${data._id}`, "DELETE", null, {
          Authorization: `Bearer ${token as string}`,
        });

        reloadHandler();
      } catch (e) {
        console.log(e);
      }
    },
  };

  return (
    <Table.Track type="banners">
      <Table.Cell text={`${order}`} />
      <Table.Cell
        text={getStringFromTranslationsArr(data.name, language.slug)}
      />
      <Table.Cell
        type="image"
        imageURL={`${config.imageProxy}public/${data.sitePhoto}`}
      />
      <Table.Cell
        type="image"
        imageURL={`${config.imageProxy}public/${data.appPhoto}`}
      />
      <Table.Cell
        type="control"
        editButton={access?.banner?.change}
        deleteButton={access?.banner?.delete}
        editHandler={Events.editHandler}
        deleteHandler={Events.deleteHandler}
      />
    </Table.Track>
  );
};

export default Track;
